import { nocturnalUndertones } from "./nocturnalUndertones";
import { searchingForLove } from "./searchingForLove";
import { earth } from "./earth";
import { Game } from "./types";


export const gameCatalog: Game[] = [
    searchingForLove,
    nocturnalUndertones,
    earth
]